export type AuthProvider = 'firebase' | 'google' | 'misskey'

const STORAGE_KEY = 'shiboruu:authProvider'

const hasLocalStorage = (): boolean => {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
}

export const getAuthProvider = (): AuthProvider | null => {
  if (!hasLocalStorage()) return null

  const v = window.localStorage.getItem(STORAGE_KEY) ?? ''
  if (['firebase', 'google', 'misskey'].includes(v)) return v as AuthProvider
  return null
}

export const setAuthProvider = (provider: AuthProvider): void => {
  if (!hasLocalStorage()) return
  window.localStorage.setItem(STORAGE_KEY, provider)
}

export const clearAuthProvider = (): void => {
  if (!hasLocalStorage()) return
  window.localStorage.removeItem(STORAGE_KEY)
}
